export const LOGIN_USER = "LOGIN_USER"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"

export const LOGOUT_USER = "LOGOUT_USER"
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS"
export const API_ERROR = "LOGIN_API_ERROR"

export const SOCIAL_LOGIN = "SOCIAL_LOGIN"

export const FORM_LOGIN = "FORM_LOGIN"
export const CLEAR_FORM_LOGIN = "CLEAR_FORM_LOGIN"
export const SET_CURRENT_PROFILE = "SET_CURRENT_PROFILE"
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS"
export const USER_LOGOUT = "USER_LOGOUT"
export const SET_FORGOT_PASSWORD_CONFIRMATION_STATUS = "SET_FORGOT_PASSWORD_CONFIRMATION_STATUS"
export const SUCCESS_MESSAGE = "SUCCESS_MESSAGE"
export const CLEAR_SUCCESS_MESSAGE = "CLEAR_SUCCESS_MESSAGE"
export const SET_FORGOT_PASSWORD_PENDING = "SET_FORGOT_PASSWORD_PENDING"
export const RESET_PASSWORD_PENDING = "RESET_PASSWORD_PENDING"
export const CLEAR_RESET_PASSWORD_PENDING = "CLEAR_RESET_PASSWORD_PENDING"
export const REDIRECT_TO_LOGIN = "REDIRECT_TO_LOGIN"


// Login
export const LOGIN_PENDING = 'LOGIN_PENDING'
export const LOGIN_PENDING_ERROR = "LOGIN_PENDING_ERROR"
export const LOGIN_PENDING_SUCCESS = "LOGIN_PENDING_SUCCESS"
export const LOGIN_ERROR = "LOGIN_ERROR"
export const CLEAR_LOGIN_ERROR = " CLEAR_LOGIN_ERROR"
export const ENABLE_USER_ERROR = "ENABLE_USER_ERROR"
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR"
export const ENABLE_USER_PENDING = "ENABLE_USER_PENDING"
export const ENABLE_USER_PENDING_SUCCESS = "ENABLE_USER_PENDING_SUCCESS"
export const CLEAR_ENABLE_USER_ERROR = "CLEAR_ENABLE_USER_ERROR"
export const ENABLE_USER_PENDING_ERROR = " ENABLE_USER_PENDING_ERROR"
export const FORGOT_PASSWORD_FORM = "FORGOT_PASSWORD_FORM"
export const RESET_PASSWORD_FORM = "RESET_PASSWORD_FORM"
export const FORM_REGISTER = "FORM_REGISTER"
export const SET_IS_LOADING = "SET_IS_LOADING"